<h2 mat-dialog-title>
  {{ form.get('id')?.value ? 'Edit assignment role' : 'Add assignment role' }}
</h2>

<mat-dialog-content [formGroup]="form" class="dialog-content">
  <mat-form-field appearance="outline" class="full-width">
    <mat-label>Name</mat-label>
    <input matInput formControlName="name" />
    <mat-error *ngIf="form.get('name')?.hasError('required')">Name is required</mat-error>
  </mat-form-field>

  <mat-form-field appearance="outline" class="full-width">
    <mat-label>Description</mat-label>
    <textarea matInput formControlName="description" rows="2"></textarea>
  </mat-form-field>

  <mat-form-field appearance="outline" class="full-width">
    <mat-label>Shared email</mat-label>
    <input matInput formControlName="sharedEmail" />
    <mat-error *ngIf="form.get('sharedEmail')?.hasError('email')">Invalid email</mat-error>
  </mat-form-field>

  <mat-form-field appearance="outline" class="full-width">
    <mat-label>Type</mat-label>
    <mat-select formControlName="type">
      @for (type of assignmentRoleTypes; track type) {
        <mat-option [value]="type">{{ type }}</mat-option>
      }
    </mat-select>
  </mat-form-field>

  <mat-checkbox formControlName="sendToAll">Send to all</mat-checkbox>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="cancel()">Cancel</button>
  <button mat-flat-button color="primary" (click)="save()" [disabled]="form.invalid">Save</button>
</mat-dialog-actions>
